module.exports = __webpack_public_path__ + "static/media/image.cb510005.svg";